import { render, staticRenderFns } from "./CustomerInfoErrorView.vue?vue&type=template&id=415936f9&scoped=true"
import script from "./CustomerInfoErrorView.vue?vue&type=script&lang=ts"
export * from "./CustomerInfoErrorView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415936f9",
  null
  
)

export default component.exports